/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import configuration from '../api/configuration';
import axios from 'axios';
import generateGuid from '../utils/generateGuid';
import PageLoader from '../components/Common/PageLoader';
// import { useTranslation } from 'react-i18next';
// import { useMutation } from '@apollo/react-hooks';
// import { UPDATE_IMAGE_PRODUCT } from '../graphql/mutations/products';
// import notify from '../utils/notify';

export default (img = null) => {
  // const [updateObject] = useMutation(UPDATE_IMAGE_PRODUCT);
  const [loadingInternal, setLoadingInternal] = useState(false);
  // const { t: notifications } = useTranslation('notifications');
  let input = null;

  const chooseFileCell = async (target) => {
    setLoadingInternal(true);
    const file = target.files[0];
    const key = generateGuid().concat(`/${file.name}`);
    const { data } = await configuration.get(
      `getPresignedUrl?key=${key}&verb=2&contentType=${file.type}`
    );
    await axios.put(data, file, {
      headers: {
        'Content-Type': file.type
      }
    });
    // updateObject({
    //   variables: {
    //     id: id,
    //     fileKey: key
    //   }
    // }).then(() => {
    //   notify({
    //     t: notifications,
    //     type: 'success',
    //     textMessage: notifications('IMAGE_UPDATED')
    //   });
    //   img.UpdateableObject.refetch();
    // });
  };

  const renderLoading = () => loadingInternal && <PageLoader />;

  const src = img.src == '' ? 'img/perfil_default.png' : img.src;

  return (
    <>
      {renderLoading()}
      <div className='multi_container'>
        {img && (
          <>
            <label
              style={{
                backgroundImage: 'url(' + src + ')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                width: img.width,
                height: img.height,
                borderRadius: img.radius,
                margin: img.margin,
                float: 'left',
                cursor: img.UpdateableObject ? 'pointer' : 'auto'
              }}
              onClick={() => {
                img.UpdateableObject && input.click();
              }}
            ></label>
            {img.UpdateableObject && (
              <input
                ref={e => (input = e)}
                id='file_upload_cell'
                type='file'
                onChange={e => {
                  chooseFileCell(e.target, img.UpdateableObject.id);
                }}
                accept='image/x-png,image/gif,image/jpeg'
              />
            )}
          </>
        )}
      </div>
    </>
  );
};
